const COOKIE_NAME = "list_attribution";
const COOKIE_EXPIRY_MINUTES = 30;

function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length !== 2) return null;

  return parts.pop()?.split(";").shift() || null;
}

function setCookie(name: string, value: string, minutes: number) {
  const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

export function updateListAttribution(listId: string | undefined | null) {
  if (!listId) return;
  const now = new Date().toISOString();
  let cookieData: Record<string, { timestamp: string }> = {};

  const existing = getCookie(COOKIE_NAME);
  if (existing) {
    try {
      cookieData = JSON.parse(existing);
    } catch (err) {
      console.warn("Invalid cookie format, resetting:", err);
      cookieData = {};
    }
  }

  cookieData[listId] = { timestamp: now };

  const jsonString = JSON.stringify(cookieData);
  setCookie(COOKIE_NAME, jsonString, COOKIE_EXPIRY_MINUTES);
}
